
const actions = {

    preloader (context, valor) {


    },
   
    
  
}

export default actions